import { Routes, Route } from "react-router-dom";
import RegistrationForm from "./components/RegistrationForm";
import { CssFormGuard, CssAccessPage } from "./components/CssFormAccess";
import NavBar from "./components/layout/NavBar";
import Home from "./pages/Home";
import Festivalaki from "./pages/Festivalaki";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Success from "./pages/Success";
import Contact from "./pages/Contact";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

function App() {
	return (
		<AuthProvider>
			<div>
				<NavBar />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/festivalaki" element={<Festivalaki />} />
					<Route path="/festivalaki/registration-26" element={<RegistrationForm />} />
					<Route path="/festivalaki/registration-success" element={<Success />} />
					<Route path="/festivalaki/registration-26-css-access" element={<CssAccessPage />} />
					<Route
						path="/festivalaki/registration-26-css"
						element={
							<CssFormGuard>
								<RegistrationForm formKey="registration-26-css" />
							</CssFormGuard>
						}
					/>
					<Route path="/login" element={<Login />} />
					<Route path="/contact" element={<Contact />} />
					<Route
						path="/registrations"
						element={
							<ProtectedRoute>
								<Admin />
							</ProtectedRoute>
						}
					/>
					<Route
						path="*"
						element={
							<div className="page-container">
								<h2>Sorry — we couldn't find that page.</h2>
							</div>
						}
					/>
				</Routes>
			</div>
		</AuthProvider>
	);
}

export default App;
